import { render, staticRenderFns } from "./assignmentDetail.vue?vue&type=template&id=7f716546"
import script from "../../controllers/assignment/assignment-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/assignment/assignment-detail.js?vue&type=script&lang=js&external"
import style0 from "./assignmentDetail.vue?vue&type=style&index=0&id=7f716546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports